<ng-template #refresh>
    <app-component-loading size="inline"></app-component-loading>
</ng-template>

<div class="wrap">
  <span class="title">Список документов: {{attachType === 'file'? 'Файлы' : 'Сканы' }}</span>
    <ul class="attach-list">
        <li *ngFor="let attach of attachments; let index=index" >
            <span>{{index+1}}.</span>
            <div 
                (click)="openFile(attach.attachment.key||attach.attachment.ukey, attach.attachment_type,attach.attachment.name)"
                data-cy="openFile" class="attach-list-name">
                {{attach.attachment.name }} 
            </div>
            <span class="attach-list-time">
                {{(attach?.attachment?.latest_version?.created_at||attach?.created_at) | date:'dd/MM/yy, HH:mm:ss'  }}
            </span>
            <app-contract-avatar  [avatarSize]="'36px'" [userGuid]="attach?.attachment.latest_version?.guid_owner"> </app-contract-avatar>
        </li>
    </ul>
</div>
